import styled from 'styled-components';

import List from '@components/List/next';

export const SearchBarList = styled(List)`
  width: 100%;
  max-height: 300px;
  overflow-y: scroll;
  position: relative;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    max-height: initial;

    grid-row: 2/3;
    width: 100%;
    height: 100%;
    overflow: auto;
    transition: all 0.5s;
  }
`;

export const SearchBarListItem = styled.li`
  padding: 12px 0 12px 20px;
  border: none;
  display: flex;
  justify-content: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 8px;

  :hover {
    background-color: rgba(250, 87, 81, 0.1);
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    padding: 12px 0px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.lighterGray};
  }
`;

export const ItemTextWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const ItemText = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.matterHorn};
`;
